// extracted by mini-css-extract-plugin
export default {"title":"ExportHistoryColumns_title__9TPga","subtitle":"ExportHistoryColumns_subtitle__qW9qn"};